module.exports = __webpack_public_path__ + "img/img111.7e66c5ce.jpg";